/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overwrite_Settings_ConfirmInputs */

const en_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will overwrite your current settings. Are you sure you want to continue?`)
};

const fr_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceci écrasera vos paramètres actuels. Êtes-vous sûr de vouloir continuer ?`)
};

const de_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dadurch werden Ihre aktuellen Einstellungen überschrieben. Möchten Sie fortfahren?`)
};

const it_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le impostazioni correnti verranno sovrascritte. Vuoi continuare?`)
};

const ru_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это перезапишет ваши текущие настройки. Вы уверены, что хотите продолжить?`)
};

const es_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto sobrescribirá tu configuración actual. ¿Estás seguro de que deseas continuar?`)
};

const zh_cn2_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这将覆盖您当前的设置。您确定要继续吗？`)
};

const ja_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これにより現在の設定が上書きされます。続行してもよろしいですか?`)
};

const hi_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इससे आपकी मौजूदा सेटिंग्स ओवरराइट हो जाएंगी। क्या आप वाकई जारी रखना चाहते हैं?`)
};

const pt_pt2_overwrite_settings_confirm = /** @type {(inputs: Overwrite_Settings_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso irá sobrescrever suas configurações atuais. Tem certeza de que deseja continuar?`)
};

/**
* | output |
* | --- |
* | "This will overwrite your current settings. Are you sure you want to continue?" |
*
* @param {Overwrite_Settings_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const overwrite_settings_confirm = /** @type {((inputs?: Overwrite_Settings_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overwrite_Settings_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_overwrite_settings_confirm(inputs)
	if (locale === "de") return de_overwrite_settings_confirm(inputs)
	if (locale === "it") return it_overwrite_settings_confirm(inputs)
	if (locale === "ru") return ru_overwrite_settings_confirm(inputs)
	if (locale === "es") return es_overwrite_settings_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_overwrite_settings_confirm(inputs)
	if (locale === "ja") return ja_overwrite_settings_confirm(inputs)
	if (locale === "hi") return hi_overwrite_settings_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_overwrite_settings_confirm(inputs)
	return en_overwrite_settings_confirm(inputs)
});